import React from "react";

import { Form, Formik } from "formik";
import { Redo } from "icons";

import { Button, Typography, PageLoader } from "clearsense-ui/components";
import { Switch } from "clearsense-ui/components/formik";

import { dataCy } from "./utils";

const Streams = ({
  streams,
  setStreams,
  setConnectionType,
  initialStreamValues,
  isConnectionSetup,
  setIsConnectionSetup,
  handleConnection,
  isLoading,
}) => {
  const handleSubmit = values => {
    const temp = Object.keys(values).filter(key => values[key]);
    const temper = streams.map(singleStream =>
      temp.includes(singleStream.stream.name)
        ? {
            ...singleStream,
            config: { ...singleStream.config, selected: true },
          }
        : {
            ...singleStream,
            config: { ...singleStream.config, selected: false },
          }
    );
    setIsConnectionSetup(true);
    setStreams(temper);
  };

  if (isLoading) {
    return (
      <div>
        <Typography style="h5" className="m-4 text-center">
          We are fetching the schema of your data source. This should take less
          than a minute, but may take a few minutes on slow internet connections
          or data sources with a large amount of tables.
        </Typography>
        <PageLoader />
      </div>
    );
  }

  return (
    <>
      {streams.length > 0 && (
        <>
          <Typography
            style="h4"
            className="mt-6 border-b-2"
            data-cy="streams-activate-message"
          >
            Activate the streams you want to sync
          </Typography>
          <Formik initialValues={initialStreamValues} onSubmit={handleSubmit}>
            <Form className="my-4 space-y-4" data-cy="streams-form">
              {streams.map(stream => (
                <Switch
                  key={stream.stream.name}
                  label={stream.stream.name}
                  name={stream.stream.name}
                  value={stream.config.selected}
                  data-cy={`${dataCy(stream.stream.name)}-switch`}
                />
              ))}
              {isConnectionSetup ? (
                <Typography
                  className="text-green-400"
                  data-cy="stream-success-message"
                >
                  Streams selected successfully
                </Typography>
              ) : (
                <div className="flex space-x-4">
                  {!setConnectionType && (
                    <Button
                      label="Refresh Schema"
                      className="self-center"
                      style="secondary"
                      icon={Redo}
                      iconPosition="left"
                      onClick={handleConnection}
                      data-cy="refresh-schema-button"
                    />
                  )}
                  <Button
                    type="submit"
                    label="Select streams"
                    data-cy="submit-streams-button"
                  />
                </div>
              )}
            </Form>
          </Formik>
        </>
      )}
    </>
  );
};

export default Streams;
